import script from "./NavigationView.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationView.vue?vue&type=script&setup=true&lang=js"

import "./NavigationView.vue?vue&type=style&index=0&id=ca8b553e&scoped=true&lang=css"
import "./NavigationView.vue?vue&type=style&index=1&id=ca8b553e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca8b553e"]])

export default __exports__